
import { Modal } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import QRCartSection from "../Scanner/commponent/QRCartSection/QRCartSection";
import useQRScanner from "./commponent/hook/useQRScanner";
import "./style/qrcodescane.css";
const QRScanner = () => {

  const {
    videoRef,
    selectedCustomer,
    showCustomerModal,
    customerSearch,
    setCustomerSearch,
    customers,
    customerLoading,
    showCustomerDropdown,
    setShowCustomerDropdown,
    activeCustomerIndex,
    setActiveCustomerIndex,
    scanning,
    starting,
    error,
    product,
    productLoading,
    productError,
    showProductModal,
    currentImage,
    productImages,
    nextImage,
    previousImage,
    productName,
    qualityName,
    designShade,
    closeCustomerModal,
    closeProductModal,
    closeScannerPage,
    scanAgain,
    handleCustomerSelect,
    handleCustomerKeyDown,
    highlightText,
  } = useQRScanner();


  return (
    <div className="qr-scanner-page">
      <button
        type="button"
        className="qr-page-close-button"
        onClick={closeScannerPage}
        aria-label="Close scanner"
      >
        <i className="bi bi-x-lg" />
      </button>


      <Toaster
        position="top-right"
        reverseOrder={false}
      />


      {/* =========================================
          CAMERA
      ========================================= */}

      <div className="qr-camera-container">

        <video
          ref={videoRef}
          className="qr-camera-video"
          autoPlay
          muted
          playsInline
        />

        <div className="qr-camera-overlay" />
        <div className="qr-custom-frame">
          <span className="corner top-left" />
          <span className="corner top-right" />
          <span className="corner bottom-left" />
          <span className="corner bottom-right" />
          <div className="qr-scan-line" />
        </div>


        <div className="qr-bottom-bar">
          {starting && (
            <div className="qr-status">
              <span className="spinner-border spinner-border-sm" />
              Starting camera...
            </div>
          )}


          {scanning && !starting && (
            <div className="qr-status">
              <span className="qr-live-dot" />
                QR code Scanner
            </div>
          )}
        </div>
      </div>


      {/* =========================================
          CAMERA ERROR
      ========================================= */}

      {error && (
        <div className="qr-error-box">
          <div className="qr-error-message">
            {error}
          </div>

          <button
            type="button"
            className="qr-retry-button"
            onClick={scanAgain}
          >
            Try Again
          </button>

        </div>
      )}




      {/* =========================================
          CUSTOMER MODAL
      ========================================= */}

      <Modal
        show={showCustomerModal}
        onHide={closeCustomerModal}
        centered
        fullscreen
        backdrop="static"
        keyboard={false}
      >

        <Modal.Header
          closeButton
          style={{
            padding: "0",
            border: "none",
          }}
        />


        <Modal.Body>
          <div
            className="position-relative"
            style={{
              margin: "0 auto",
              width: "35%",
            }}
          >

            <input
              type="search"
              className="form-control shadow"
              placeholder="Search Customer..."
              value={customerSearch}
              autoFocus
              onChange={(e) => {
                setCustomerSearch(
                  e.target.value
                );

                setShowCustomerDropdown(
                  true
                );

                setActiveCustomerIndex(
                  -1
                );
              }}

              onFocus={() => {
                if (
                  customerSearch.trim() &&
                  customers.length
                ) {
                  setShowCustomerDropdown(
                    true
                  );
                }
              }}

              onKeyDown={
                handleCustomerKeyDown
              }
            />


            {showCustomerDropdown && (
              <div
                className="customer-dropdown"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  zIndex: 9999,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius:
                    "0 0 8px 8px",
                  boxShadow:
                    "0 5px 15px rgba(0,0,0,0.12)",
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >

                {customerLoading ? (

                  <div className="text-center py-3">
                    Searching...
                  </div>

                ) : customers.length > 0 ? (

                  customers.map(
                    (
                      customer,
                      index
                    ) => {

                      const isActive =
                        index ===
                        activeCustomerIndex;

                      return (
                        <div
                          key={
                            customer.id ||
                            index
                          }
                          role="option"
                          aria-selected={
                            isActive
                          }

                          onClick={() =>
                            handleCustomerSelect(
                              customer
                            )
                          }

                          onMouseEnter={() =>
                            setActiveCustomerIndex(
                              index
                            )
                          }

                          style={{
                            padding:
                              "12px 15px",
                            cursor:
                              "pointer",
                            borderBottom:
                              "1px solid #eee",
                            backgroundColor:
                              isActive
                                ? "#f1f1f1"
                                : "#fff",
                          }}
                        >

                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "15px",
                              color: "#222",
                            }}
                          >
                            {highlightText(
                              customer.accountName,
                              customerSearch
                            )}
                          </div>
                        </div>
                      );
                    }
                  )

                ) : (

                  <div className="text-center py-3 text-muted">
                        No customer found
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>



      {/* =========================================
          PRODUCT MODAL
      ========================================= */}

      <Modal
        show={showProductModal}
        onHide={closeProductModal}
        fullscreen
        backdrop="static"
        keyboard={false}
      >

        <Modal.Header closeButton>
          <Modal.Title>
            {productLoading
              ? "Loading Product..."
              : qualityName}
            {!productLoading &&
              designShade && (
                <>
                  {" "}

                  <span
                    style={{
                      color: "#F00",
                    }}
                  >
                    {designShade}
                  </span>

                </>
              )}

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {productLoading ? (
            <div className="qr-product-loading">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
              />

              <div className="mt-3">
                Loading product...
              </div>

              <div
                className="text-muted mt-2"
                style={{
                  fontSize: "14px",
                }}
              >
                Please wait...
              </div>

            </div>

          ) : product ? (

            <div className="row">

              {/* =====================================
                  PRODUCT IMAGE
              ===================================== */}

              <div className="col-md-4">

                {productImages.length > 0 ? (

                  <div className="qr-product-single-carousel">

                    {productImages.length > 1 && (
                      <button
                        type="button"
                        className="qr-carousel-btn qr-carousel-left"
                        onClick={
                          previousImage
                        }
                      >
                        <i className="bi bi-chevron-left" />
                      </button>
                    )}


                    <div className="qr-product-gallery">

                      <div
                        className="qr-product-gallery-track"
                        style={{
                          transform:
                            `translate3d(-${
                              currentImage *
                              100
                            }%, 0, 0)`,
                        }}
                      >

                        {productImages.map(
                          (
                            imageUrl,
                            index
                          ) => (
                            <div
                              className="qr-product-image"
                              key={`${imageUrl}-${index}`}
                            >

                              <img
                                src={imageUrl}
                                alt={
                                  productName
                                }
                              />

                            </div>
                          )
                        )}

                      </div>

                    </div>


                    {productImages.length > 1 && (
                      <button
                        type="button"
                        className="qr-carousel-btn qr-carousel-right"
                        onClick={
                          nextImage
                        }
                      >
                        <i className="bi bi-chevron-right" />
                      </button>
                    )}


                    {productImages.length > 1 && (
                      <div className="qr-image-counter">

                        {currentImage + 1} /{" "}
                        {productImages.length}

                      </div>
                    )}

                  </div>

                ) : (

                  <div className="qr-no-image">
                    No image available
                  </div>

                )}

              </div>


              {/* =====================================
                  CART SECTION
              ===================================== */}

              <div className="col-md-8">

                <QRCartSection
                  product={product}
                  customer={
                    selectedCustomer
                  }
                />

              </div>

            </div>

          ) : (

            <div className="text-center py-5">
              {productError ||
                "Product not found."}
            </div>

          )}

        </Modal.Body>
      </Modal>


    </div>
  );
};

export default QRScanner;
